<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="languageDetails">
          <AddIndependentLesson
            :languageDetails="languageDetails"
            @reFetchIndependentLessons="reFetchIndependentLessons"
          ></AddIndependentLesson>
          <hr class="my-2" />
          <IndependentLessonsList
            ref="independentLessonsList"
          ></IndependentLessonsList>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import Draggable from "vuedraggable";
export default {
  mounted() {
    this.getASingleLanguage();
  },
  data() {
    return {
      isReOrderButtonDisabled: true,
      isLoading: false,
      languageDetails: null,
      independentLessonFilters: {
        languageId: this.$route.params.id,
        title: null,
        pageNumber: 1,
        count: 200,
      },
      newIndependentLessonDetails: {
        priority: 0,
        languageId: this.$route.params.id,
        isRequired: true,
        title: null,
        description: null,
        price: null,
        justBasic: true,
        mainImage: null,
      },
      lessonImage: null,
      tempBase64: null,
      alreadyCreatedLessons: null,
      myTableColumns: [
        {
          key: "handler",
          label: "تغییر اولویت",
        },
        {
          key: "priority",
          label: "اولویت",
        },
        {
          key: "title",
          label: "نام درس",
        },
        {
          key: "isRequired",
          label: "اجباری است؟",
        },
        {
          key: "justBasic",
          label: "ثبت در نقشه راه",
        },
        {
          key: "price",
          label: "قیمت درس",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  methods: {
    reFetchIndependentLessons() {
      if (this.$refs.independentLessonsList) {
        this.$refs.independentLessonsList.getAllIndependentLessons &&
          this.$refs.independentLessonsList.getAllIndependentLessons();
      }
    },
    async getASingleLanguage() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleLanguage = new GetASingleLanguage(_this);
        getASingleLanguage.setRequestParam({ id: _this.$route.params.id });
        await getASingleLanguage.fetch((res) => {
          _this.languageDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BLink,
    BBadge,
    BOverlay,
    BFormFile,
    BFormTextarea,
    BModal,
    BContainer,
    Draggable,
    BTableSimple,
    BTr,
    BTd,
    BTh,
    BThead,
    AddIndependentLesson,
    IndependentLessonsList,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BLink,
  BBadge,
  BOverlay,
  BFormFile,
  BFormTextarea,
  BModal,
  BContainer,
  BTableSimple,
  BTr,
  BTd,
  BTh,
  BThead,
} from "bootstrap-vue";
import { GetASingleLanguage } from "@/libs/Api/Language";
import IndependentLessonsList from "@/views/components/IndependentLesson/IndependentLessonsList.vue";
import AddIndependentLesson from "@/views/components/IndependentLesson/AddIndependentLesson.vue";
</script>
